// @ts-nocheck
import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'

import styles from './Score.module.scss'

export const Score = React.forwardRef(
  (
    { fieldClassName, id, name, score, onBlur, onChange, isDisabled = false },
    ref,
  ) => (
    <input
      className={cx(styles.score, {
        [fieldClassName]: Boolean(fieldClassName),
      })}
      type="radio"
      value={score}
      disabled={isDisabled}
      {...{ id, name, ref, onBlur, onChange }}
    />
  ),
)

export const ControlledScore = ({
  control,
  fieldClassName,
  id,
  name,
  score,
  isDisabled,
}) => (
  <Controller
    render={({ field: { name, ref, onBlur, onChange } }) => (
      <Score
        {...{
          fieldClassName,
          id,
          name,
          ref,
          score,
          onBlur,
          onChange,
          isDisabled,
        }}
      />
    )}
    {...{ control, name }}
  />
)
